import React, { useState, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAppContext } from '../store/AppContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { checkKeywordPosition } from '../utils/api';
import ReactECharts from 'echarts-for-react';
import html2canvas from 'html2canvas';

const {
  FiArrowLeft, FiPlus, FiRefreshCw, FiEdit2, FiBarChart2, FiTrash2,
  FiCheck, FiAward, FiX, FiCalendar, FiCamera, FiDownload,
  FiTrendingUp, FiTrendingDown, FiMinus, FiStar, FiGlobe,
  FiTarget, FiAlertCircle
} = FiIcons;

const getFaviconUrl = (url) => {
  try {
    const u = url.startsWith('http') ? url : `https://${url}`;
    const domain = new URL(u).hostname;
    return `https://www.google.com/s2/favicons?domain=${domain}&sz=64`;
  } catch { return null; }
};

const CompanyLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 216" width="400%" height="400%">
    <g fill="#008055" strokeWidth="0">
      <path d="M184 59.3c10.5 3.2 17 7 23.9 14.1 9.5 10 14.1 21.2 14.1 34.7 0 22.3-15.6 42.3-37.7 48.4l-4.8 1.3 4.8.1c9.7.2 23.8-6.8 31.9-15.7 15.1-16.7 17.2-42.9 5-61.8-4.5-7-12.3-14.2-18.9-17.6-5.8-3-16.4-5.8-21.9-5.7-3.5 0-3.2.2 3.6 2.2"/>
      <path d="M161.4 80c-11.2 12.5-13.5 16.8-13.5 24.6 0 9.2 2.4 12.7 19.6 27.9 8.4 7.4 16.1 13.5 17 13.5 1 0-4.3-6.3-13.2-15.6-8.1-8.5-15.3-16.5-16-17.7-1.7-3-1.6-11.2.1-14.5.8-1.5 7.1-8.3 14-15.2S182 70.2 182 69.8c0-.5-2.4-.8-5.4-.8h-5.4z"/>
      <path d="M183.8 81.6c-11.5 11.8-13.3 15.1-13.3 23.9.1 10.5 1.3 12.4 20.3 29.2 4.1 3.6 6.6 5.3 7.3 4.6.6-.6-2.5-4.6-8.7-11.4-11.3-12.3-13.9-17-12.9-23.8.6-4.2 1.7-5.6 11.7-15.7l10.9-11.2-2.9-2.1c-1.7-1.1-3.3-2.1-3.6-2.1s-4.2 3.9-8.8 8.6m121.4-3.9c-3.8.7-10 7.6-10.4 11.5-.8 8.8 2.9 15.6 10 17.9 4.5 1.5 13.3.7 16.6-1.4 2.3-1.6 2.6-2.4 2.6-7.7v-6h-3.9c-4 0-4 0-4.3 4.2s-.4 4.3-4 4.6c-7.1.6-11.3-7.1-7.2-13.3 2.1-3.3 7.3-4.2 11.5-2.1 3.1 1.5 3.4 1.5 5.6-.6 1.9-1.7 2.1-2.4 1-3.6-2.8-3.4-10.2-4.9-17.5-3.5M246 93.1v15.2l9.9-.5c11.2-.5 15.1-2.2 18.8-7.8 4.4-6.5 2.1-15.7-4.9-20-2.7-1.6-5.1-2-13.5-2H246zm20.2-6.4c1.2 1.1 1.8 3 1.8 5.8 0 5.5-2.5 7.9-8.6 7.9l-4.6.1.1-7.8c0-4.2 0-8 .1-8.3 0-1.3 9.4.6 11.2 2.3M282 93v15h8V78h-8zm47 0v15h8V78h-8zm13-12c0 2.9.2 3 4.5 3h4.4l.3 11.7.3 11.8 4.3.3 4.2.3V84h4.5c4.3 0 4.5-.1 4.5-3v-3h-27zm36.3.7c-.8 2.1-3.7 8.7-6.4 14.7s-4.9 11.1-4.9 11.3 1.9.3 4.2.1c3.5-.2 4.5-.8 5.6-3.1 1.2-2.5 1.7-2.7 7.6-2.7 6.1 0 6.4.1 7.6 3 1.1 2.7 1.7 3 5.6 3 2.4 0 4.4-.1 4.4-.3s-2.9-6.8-6.5-14.7-6.5-14.5-6.5-14.7-2-.3-4.6-.3c-4.3 0-4.6.2-6.1 3.7m6.6 13.1c-1.7.2-3.3.2-3.5-.1-.2-.2.3-2.1 1.2-4.3l1.7-3.9 1.8 4 1.8 4zm19.3-2.1.3 14.8 11.3.3 11.2.3V101h-14V78h-9.1z"/>
      <path d="M197.7 94.9c-12.2 12.5-12.1 13.8 2.2 27.8l7.6 7.4 3-6.3c2.7-5.7 3-7.2 3-16.3-.1-9-.3-10.6-2.9-15.8-1.6-3.1-3.2-5.7-3.6-5.7-.3 0-4.5 4-9.3 8.9m50.3 34.7c0 7.2.3 9.5 1.3 9.2.8-.3 1.3-3.4 1.5-9.6.2-7.7 0-9.2-1.3-9.2-1.2 0-1.5 1.6-1.5 9.6m16.2-.4c.2 7.3.6 9.3 1.7 9.3 1.2 0 1.4-1.3 1.2-5.8-.1-3.1.2-5.7.7-5.7s3 2.7 5.7 6c2.6 3.4 5.2 5.9 5.7 5.8.5-.2 1-4.3 1-9.3 0-7.3-.3-9.1-1.6-9.3-1.2-.3-1.6.9-1.8 5.7l-.3 6.1-4.8-6c-6.8-8.6-7.8-8.2-7.5 3.2m29.8 0v9.3l7.1-.3c6.3-.3 7.1-.6 8.1-2.7.8-1.9.7-3-.5-4.9-1-1.5-1.3-2.7-.7-3.1 1.7-1.1 1.1-4.3-1.2-5.9-1.4-1-4.4-1.6-7.5-1.6H294zm11.5-5.2c1.2 1.9-1.6 4-5.1 4-3 0-3.4-.3-3.4-2.5s.4-2.5 3.9-2.5c2.2 0 4.3.5 4.6 1m0 7.6c2.3 2.3.2 4.4-4.6 4.4-3.7 0-3.9-.2-3.9-3s.3-3 3.4-3c1.9 0 4.2.7 5.1 1.6m19.2-10.5c-.9.5-2.4 2.4-3.3 4.1-4.1 8 5.2 16.6 13.4 12.4 3.8-2 5.2-4.4 5.2-8.9 0-6.5-9.3-11.1-15.3-7.6m10.7 4.1c2.2 3.1 2 5.8-.6 8.5-2.5 2.7-5.4 2.9-8.6.7-2.7-1.8-3-6.9-.5-9.6 2.3-2.6 7.8-2.4 9.7.4M352 127c0 6.3.3 7.4 2.6 9.7 2.1 2.1 3.2 2.4 6.2 1.9 5.5-.8 7.2-3.5 7.2-11.7 0-5.5-.3-6.9-1.5-6.9s-1.5 1.3-1.5 5.8c0 6.3-1.9 10.2-5 10.2-3.6 0-5-2.7-5-9.6 0-5-.3-6.4-1.5-6.4s-1.5 1.4-1.5 7m29 2.5c0 7.8.3 9.5 1.5 9.5s1.5-1.3 1.5-6c0-3.3.3-6 .8-5.9.4 0 2.9 2.7 5.5 6 2.6 3.2 5.2 5.9 5.7 5.9.6 0 1-4 1-9.5 0-7.6-.3-9.5-1.5-9.5-1 0-1.5 1.6-1.7 6.2l-.3 6.2-5-6.2c-2.7-3.4-5.6-6.2-6.2-6.2-1 0-1.3 2.6-1.3 9.5m29.2-.3.3 9.1 4.3-.1c2.3 0 5.1-.1 6.2-.1 3.5-.2 7-4.5 7-8.8 0-6.5-3.7-9.3-12.3-9.3h-5.8zm13-4.5c2.1 1.9 2.3 6 .3 8.6-.7 1.1-3.2 2.1-5.4 2.4l-4.1.6V123h3.7c2 0 4.5.7 5.5 1.7"/>
    </g>
  </svg>
);

const getRankColor = (pos) => {
  if (pos <= 3) return { bg: 'bg-emerald-500', light: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200', label: 'TOP 3' };
  if (pos <= 10) return { bg: 'bg-indigo-500', light: 'bg-indigo-50', text: 'text-indigo-700', border: 'border-indigo-200', label: 'TOP 10' };
  if (pos <= 30) return { bg: 'bg-amber-400', light: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200', label: 'TOP 30' };
  return { bg: 'bg-red-400', light: 'bg-red-50', text: 'text-red-700', border: 'border-red-200', label: '31+' };
};

const getTrend = (kw) => {
  const history = kw.positionHistory || [];
  const current = Number(kw.position);
  const distinct = [];
  for (let i = history.length - 1; i >= 0 && distinct.length < 2; i--) {
    if (distinct.length === 0 || Number(history[i].position) !== Number(distinct[distinct.length - 1].position)) {
      distinct.push(history[i]);
    }
  }
  if (distinct.length < 2) return null;
  const prev = Number(distinct[1].position);
  const diff = prev - current;
  if (diff > 0) return { type: 'up', diff, color: 'text-emerald-600', bg: 'bg-emerald-50', border: 'border-emerald-200', icon: FiTrendingUp };
  if (diff < 0) return { type: 'down', diff: Math.abs(diff), color: 'text-red-500', bg: 'bg-red-50', border: 'border-red-200', icon: FiTrendingDown };
  return { type: 'stable', diff: 0, color: 'text-slate-400', bg: 'bg-slate-50', border: 'border-slate-200', icon: FiMinus };
};

const TrendBadge = ({ kw }) => {
  const trend = getTrend(kw);
  if (!trend) return <span className="text-xs text-slate-300 italic">Prima înreg.</span>;
  const Icon = trend.icon;
  const label = trend.type === 'up' ? `+${trend.diff} poz.` : trend.type === 'down' ? `-${trend.diff} poz.` : 'Stabil';
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold border ${trend.color} ${trend.bg} ${trend.border}`}>
      <SafeIcon icon={Icon} className="text-xs" />
      {label}
    </span>
  );
};

const AdvertorialEditModal = ({ adv, onSave, onClose }) => {
  const [form, setForm] = useState({ title: adv.title, url: adv.url, date: adv.date || '' });
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 space-y-5">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-bold text-slate-800">Editează Advertorial</h3>
          <button onClick={onClose} className="p-1.5 hover:bg-slate-100 rounded-lg"><SafeIcon icon={FiX} /></button>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); onSave({ ...adv, ...form }); }} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Titlu</label>
            <input type="text" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })}
              className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500 outline-none" required />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">URL</label>
            <input type="text" value={form.url} onChange={e => setForm({ ...form, url: e.target.value })}
              className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500 outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Dată publicare</label>
            <input type="date" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })}
              className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500 outline-none" />
          </div>
          <div className="flex gap-3 pt-1">
            <button type="submit" className="flex-1 bg-indigo-600 text-white py-2 rounded-lg text-sm font-medium hover:bg-indigo-700 flex items-center justify-center gap-2">
              <SafeIcon icon={FiCheck} /> Salvează
            </button>
            <button type="button" onClick={onClose} className="flex-1 bg-slate-100 text-slate-600 py-2 rounded-lg text-sm font-medium hover:bg-slate-200">Anulează</button>
          </div>
        </form>
      </div>
    </div>
  );
};

const ErrorBanner = ({ message, onClose }) => (
  <div className="flex items-start gap-3 bg-red-50 border border-red-200 text-red-700 rounded-xl px-4 py-3 text-sm">
    <SafeIcon icon={FiAlertCircle} className="text-red-500 mt-0.5 flex-shrink-0 text-base" />
    <span className="flex-1">{message}</span>
    <button onClick={onClose} className="text-red-400 hover:text-red-600 flex-shrink-0"><SafeIcon icon={FiX} /></button>
  </div>
);

const WebsiteDetail = () => {
  const { clientId, webId } = useParams();
  const { data, setData, t } = useAppContext();
  const [activeTab, setActiveTab] = useState('keywords');
  const [loadingKw, setLoadingKw] = useState(null);
  const [apiError, setApiError] = useState(null);
  const [manualEdit, setManualEdit] = useState({ id: null, field: '', val: '' });
  const [editingAdv, setEditingAdv] = useState(null);
  const [screenshotLoading, setScreenshotLoading] = useState(false);
  const [faviconError, setFaviconError] = useState(false);
  const reportRef = useRef(null);

  const client = data.clients.find(c => c.id === clientId);
  const website = client?.websites?.find(w => w.id === webId);
  if (!website) return <div className="p-8 text-center text-slate-500">Data not found</div>;

  const faviconUrl = getFaviconUrl(website.url);

  const updateWebsiteData = (newData) => {
    setData(prev => ({
      ...prev,
      clients: prev.clients.map(c =>
        c.id === clientId
          ? { ...c, websites: c.websites.map(w => w.id === webId ? { ...w, ...newData } : w) }
          : c
      )
    }));
  };

  const appendPositionHistory = (kw, newPosition) => {
    const history = kw.positionHistory || [];
    return [...history, { position: newPosition, date: new Date().toISOString().split('T')[0], ts: Date.now() }];
  };

  const handleAddKeyword = (e) => {
    e.preventDefault();
    const term = e.target.term.value;
    const isTargeted = e.target.targeted?.checked || false;
    if (!term) return;
    const newKw = { id: `k_${Date.now()}`, term, position: '-', searchVolume: '-', lastChecked: '-', positionHistory: [], isTargeted };
    updateWebsiteData({ keywords: [...(website.keywords || []), newKw] });
    e.target.reset();
  };

  const handleDeleteKeyword = (kwId) => {
    if (window.confirm('Ești sigur că vrei să ștergi acest keyword?'))
      updateWebsiteData({ keywords: website.keywords.filter(k => k.id !== kwId) });
  };

  const handleToggleTargeted = (kwId) => {
    updateWebsiteData({ keywords: website.keywords.map(k => k.id === kwId ? { ...k, isTargeted: !k.isTargeted } : k) });
  };

  const handleCheckPos = async (kw) => {
    setLoadingKw(kw.id);
    setApiError(null);

    const result = await checkKeywordPosition(kw.term, website.url, data.settings.apiLogin, data.settings.apiPassword);

    if (result.error) {
      setApiError(result.errorMessage);
      setLoadingKw(null);
      return;
    }

    const newHistory = appendPositionHistory(kw, result.position ?? 'N/A');
    updateWebsiteData({
      keywords: website.keywords.map(k =>
        k.id === kw.id
          ? {
              ...k,
              position: result.position !== null ? result.position : 'N/A',
              searchVolume: result.searchVolume !== null ? result.searchVolume : 'N/A',
              lastChecked: new Date().toISOString().split('T')[0],
              positionHistory: newHistory,
              notFound: result.notFound,
            }
          : k
      )
    });
    setLoadingKw(null);
  };

  const handleManualUpdate = (kwId) => {
    if (manualEdit.val === '') { setManualEdit({ id: null, field: '', val: '' }); return; }
    const kw = website.keywords.find(k => k.id === kwId);
    let extra = {};
    if (manualEdit.field === 'position' && kw) extra.positionHistory = appendPositionHistory(kw, manualEdit.val);
    updateWebsiteData({
      keywords: website.keywords.map(k =>
        k.id === kwId ? { ...k, [manualEdit.field]: manualEdit.val, lastChecked: new Date().toISOString().split('T')[0], ...extra } : k
      )
    });
    setManualEdit({ id: null, field: '', val: '' });
  };

  const handleAddAdvertorial = (e) => {
    e.preventDefault();
    const title = e.target.title.value;
    const url = e.target.url.value;
    const date = e.target.date.value;
    if (!title) return;
    updateWebsiteData({ advertorials: [...(website.advertorials || []), { id: `a_${Date.now()}`, title, url, date: date || '' }] });
    e.target.reset();
  };

  const handleSaveAdv = (updated) => {
    updateWebsiteData({ advertorials: website.advertorials.map(a => a.id === updated.id ? updated : a) });
    setEditingAdv(null);
  };

  const handleDeleteAdv = (advId) => {
    if (window.confirm('Ștergi acest advertorial?'))
      updateWebsiteData({ advertorials: website.advertorials.filter(a => a.id !== advId) });
  };

  const handleScreenshot = async () => {
    if (!reportRef.current) return;
    setScreenshotLoading(true);
    try {
      const el = reportRef.current;
      const originalStyle = el.getAttribute('style') || '';
      el.style.width = '1200px';
      el.style.maxWidth = '1200px';
      window.dispatchEvent(new Event('resize'));
      await new Promise(r => setTimeout(r, 800));
      const canvas = await html2canvas(el, { scale: 2, useCORS: true, backgroundColor: '#f8fafc', logging: false });
      el.setAttribute('style', originalStyle);
      window.dispatchEvent(new Event('resize'));
      const link = document.createElement('a');
      link.download = `raport_${website.url.replace(/https?:\/\//, '').replace(/\//g, '_')}_${new Date().toISOString().split('T')[0]}.jpg`;
      link.href = canvas.toDataURL('image/jpeg', 0.95);
      link.click();
    } catch (err) {
      alert('Eroare la generarea screenshot-ului.');
    }
    setScreenshotLoading(false);
  };

  const allKws = website.keywords || [];
  const targetedKws = allKws.filter(k => k.isTargeted);
  const otherKws = allKws.filter(k => !k.isTargeted);
  const validKws = allKws.filter(k => k.position !== '-' && k.position !== 'N/A' && k.searchVolume !== '-' && k.searchVolume !== 'N/A');
  const sortedByPos = [...validKws].sort((a, b) => Number(a.position) - Number(b.position));
  const positions = validKws.map(k => Number(k.position));
  const volumes = validKws.map(k => Number(k.searchVolume));
  const avgPosition = positions.length ? (positions.reduce((a, b) => a + b, 0) / positions.length).toFixed(1) : '-';
  const top10Count = positions.filter(p => p <= 10).length;
  const totalVolume = volumes.reduce((a, b) => a + b, 0);

  const volumeChartOptions = {
    tooltip: { trigger: 'axis', formatter: (params) => `<b>${params[0].name}</b><br/>Volum: <b>${Number(params[0].value).toLocaleString()}</b> căutări/lună` },
    grid: { left: '3%', right: '8%', bottom: '3%', top: '5%', containLabel: true },
    xAxis: { type: 'value', axisLabel: { formatter: (val) => val >= 1000 ? `${(val / 1000).toFixed(1)}k` : val, color: '#64748b' } },
    yAxis: { type: 'category', data: validKws.map(k => k.term), axisLabel: { fontSize: 12, color: '#475569', width: 180, overflow: 'truncate', ellipsis: '...' } },
    series: [{
      type: 'bar',
      data: volumes.map((vol) => ({ value: vol, itemStyle: { color: vol >= 5000 ? '#10b981' : vol >= 1000 ? '#4f46e5' : vol >= 500 ? '#8b5cf6' : '#94a3b8', borderRadius: [0, 6, 6, 0] } })),
      label: { show: true, position: 'right', formatter: (p) => Number(p.value).toLocaleString(), fontSize: 12, color: '#334155', fontWeight: 'bold' }
    }]
  };

  const getPositionDisplay = (kw) => {
    if (kw.position === '-') return '-';
    if (kw.position === 'N/A') return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold bg-slate-100 text-slate-400" title="Nerankat în top 100">
        N/A
      </span>
    );
    return (
      <span className={`inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-bold
        ${Number(kw.position) <= 3 ? 'bg-green-100 text-green-700' :
          Number(kw.position) <= 10 ? 'bg-indigo-100 text-indigo-700' :
          'bg-amber-100 text-amber-700'}`}>
        #{kw.position}
      </span>
    );
  };

  const KwRow = ({ kw }) => (
    <tr className="hover:bg-slate-50 transition-colors group">
      <td className="p-3 font-medium text-slate-800">
        {manualEdit.id === kw.id && manualEdit.field === 'term' ? (
          <div className="flex items-center gap-2">
            <input type="text" autoFocus className="flex-1 border rounded px-2 py-1 text-sm outline-none focus:ring-2 focus:ring-indigo-500"
              value={manualEdit.val} onChange={e => setManualEdit({ ...manualEdit, val: e.target.value })}
              onKeyDown={e => e.key === 'Enter' && handleManualUpdate(kw.id)} />
            <button onClick={() => handleManualUpdate(kw.id)} className="text-green-600"><SafeIcon icon={FiCheck} /></button>
          </div>
        ) : (
          <div className="flex items-center gap-2">
            {kw.isTargeted && <SafeIcon icon={FiStar} className="text-amber-400 text-xs flex-shrink-0" />}
            <span onClick={() => setManualEdit({ id: kw.id, field: 'term', val: kw.term })} className="cursor-pointer hover:text-indigo-600 flex items-center gap-1">
              {kw.term}
              <SafeIcon icon={FiEdit2} className="text-slate-300 opacity-0 group-hover:opacity-100 transition-opacity text-xs" />
            </span>
          </div>
        )}
      </td>
      <td className="p-3">
        {manualEdit.id === kw.id && manualEdit.field === 'position' ? (
          <input type="number" autoFocus className="w-20 border rounded px-2 py-1 text-sm outline-none focus:ring-2 focus:ring-indigo-500"
            value={manualEdit.val} onChange={e => setManualEdit({ ...manualEdit, val: e.target.value })}
            onBlur={() => handleManualUpdate(kw.id)} onKeyDown={e => e.key === 'Enter' && handleManualUpdate(kw.id)} />
        ) : (
          <span onClick={() => setManualEdit({ id: kw.id, field: 'position', val: kw.position === '-' ? '' : kw.position })} className="cursor-pointer hover:scale-105 transition-transform inline-block">
            {getPositionDisplay(kw)}
          </span>
        )}
      </td>
      <td className="p-3"><TrendBadge kw={kw} /></td>
      <td className="p-3">
        {manualEdit.id === kw.id && manualEdit.field === 'searchVolume' ? (
          <input type="number" autoFocus className="w-24 border rounded px-2 py-1 text-sm outline-none focus:ring-2 focus:ring-indigo-500"
            value={manualEdit.val} onChange={e => setManualEdit({ ...manualEdit, val: e.target.value })}
            onBlur={() => handleManualUpdate(kw.id)} onKeyDown={e => e.key === 'Enter' && handleManualUpdate(kw.id)} />
        ) : (
          <span onClick={() => setManualEdit({ id: kw.id, field: 'searchVolume', val: kw.searchVolume === '-' ? '' : kw.searchVolume })}
            className="flex items-center gap-1 cursor-pointer hover:text-indigo-600 font-medium text-sm">
            <SafeIcon icon={FiBarChart2} className="text-slate-400 text-xs" />
            {kw.searchVolume !== '-' && kw.searchVolume !== 'N/A' ? Number(kw.searchVolume).toLocaleString() : kw.searchVolume}
          </span>
        )}
      </td>
      <td className="p-3 text-xs text-slate-400">{kw.lastChecked || '-'}</td>
      <td className="p-3">
        <div className="flex items-center justify-center gap-1.5">
          <button onClick={() => handleToggleTargeted(kw.id)} title={kw.isTargeted ? 'Elimină din targetate' : 'Marchează ca targetat'}
            className={`p-1.5 rounded-lg transition-colors ${kw.isTargeted ? 'text-amber-500 bg-amber-50 hover:bg-amber-100' : 'text-slate-300 bg-slate-50 hover:text-amber-400 hover:bg-amber-50'}`}>
            <SafeIcon icon={FiStar} className="text-sm" />
          </button>
          <button onClick={() => handleCheckPos(kw)} disabled={loadingKw === kw.id}
            className="p-1.5 text-indigo-600 bg-indigo-50 rounded-lg hover:bg-indigo-100 disabled:opacity-50 transition-colors">
            <SafeIcon icon={FiRefreshCw} className={`text-sm ${loadingKw === kw.id ? 'animate-spin' : ''}`} />
          </button>
          <button onClick={() => handleDeleteKeyword(kw.id)} className="p-1.5 text-red-500 bg-red-50 rounded-lg hover:bg-red-100 transition-colors">
            <SafeIcon icon={FiTrash2} className="text-sm" />
          </button>
        </div>
      </td>
    </tr>
  );

  const TableHeader = () => (
    <thead className="bg-slate-50 text-slate-600 text-xs font-semibold uppercase tracking-wider border-b border-slate-200">
      <tr>
        <th className="p-3 text-left">Keyword</th>
        <th className="p-3 text-left">Poziție</th>
        <th className="p-3 text-left">Tendință</th>
        <th className="p-3 text-left">Volum</th>
        <th className="p-3 text-left">Verificat</th>
        <th className="p-3 text-center w-28">Acțiuni</th>
      </tr>
    </thead>
  );

  return (
    <div className="space-y-6">
      {editingAdv && <AdvertorialEditModal adv={editingAdv} onSave={handleSaveAdv} onClose={() => setEditingAdv(null)} />}

      {/* Header */}
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <Link to={`/clients/${clientId}`} className="p-2 hover:bg-slate-200 rounded-lg text-slate-500 transition-colors">
            <SafeIcon icon={FiArrowLeft} />
          </Link>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-white border border-slate-200 shadow-sm flex items-center justify-center overflow-hidden flex-shrink-0">
              {faviconUrl && !faviconError ? (
                <img src={faviconUrl} alt="" className="w-8 h-8 object-contain" onError={() => setFaviconError(true)} />
              ) : <SafeIcon icon={FiGlobe} className="text-xl text-slate-400" />}
            </div>
            <div>
              <h1 className="text-xl font-bold text-slate-800">{website.url.replace(/https?:\/\//, '')}</h1>
              <p className="text-sm text-slate-500">{client.name} • {allKws.length} keywords • {targetedKws.length} targetate</p>
            </div>
          </div>
        </div>
        {activeTab === 'reports' && validKws.length > 0 && (
          <button onClick={handleScreenshot} disabled={screenshotLoading}
            className="flex items-center gap-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-5 py-2.5 rounded-xl hover:from-indigo-700 hover:to-purple-700 transition-all shadow-md disabled:opacity-60 font-medium text-sm">
            {screenshotLoading ? (<><SafeIcon icon={FiRefreshCw} className="animate-spin" /> Se generează...</>) : (<><SafeIcon icon={FiCamera} /> Screenshot <SafeIcon icon={FiDownload} className="text-xs opacity-80" /></>)}
          </button>
        )}
      </div>

      {/* API Error Banner */}
      {apiError && <ErrorBanner message={apiError} onClose={() => setApiError(null)} />}

      {/* Tabs */}
      <div className="flex border-b border-slate-200">
        {['keywords', 'advertorials', 'reports'].map(tab => (
          <button key={tab} onClick={() => setActiveTab(tab)}
            className={`px-6 py-3 font-medium text-sm border-b-2 transition-colors ${activeTab === tab ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-slate-500 hover:text-slate-800'}`}>
            {t(tab)}
            {tab === 'keywords' && allKws.length > 0 && (
              <span className="ml-2 text-xs bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded-full">{allKws.length}</span>
            )}
          </button>
        ))}
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">

        {/* KEYWORDS TAB */}
        {activeTab === 'keywords' && (
          <div className="space-y-6">
            <form onSubmit={handleAddKeyword} className="flex gap-3 items-center bg-slate-50 p-4 rounded-xl border border-slate-200">
              <input name="term" placeholder="Adaugă cuvânt cheie..."
                className="flex-1 border border-slate-300 rounded-lg px-4 py-2 text-sm focus:ring-2 focus:ring-indigo-500 outline-none bg-white" />
              <label className="flex items-center gap-2 text-sm text-slate-600 cursor-pointer select-none whitespace-nowrap">
                <input type="checkbox" name="targeted" className="w-4 h-4 accent-amber-400 rounded" />
                <SafeIcon icon={FiStar} className="text-amber-400" /> Targetat
              </label>
              <button type="submit" className="bg-indigo-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-indigo-700 transition-colors text-sm font-medium whitespace-nowrap">
                <SafeIcon icon={FiPlus} /> Adaugă
              </button>
            </form>

            {!data.settings.apiLogin && (
              <div className="flex items-center gap-3 bg-amber-50 border border-amber-200 text-amber-700 rounded-xl px-4 py-3 text-sm">
                <SafeIcon icon={FiAlertCircle} className="text-amber-500 flex-shrink-0" />
                <span>API-ul DataForSEO nu este configurat. Adaugă credențialele în <strong>Setări → DataForSEO API</strong> pentru date reale.</span>
              </div>
            )}

            {targetedKws.length > 0 && (
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <div className="flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-lg px-3 py-1.5">
                    <SafeIcon icon={FiTarget} className="text-amber-500 text-sm" />
                    <span className="text-sm font-bold text-amber-700">Cuvinte Cheie Targetate</span>
                    <span className="text-xs bg-amber-200 text-amber-800 px-1.5 py-0.5 rounded-full font-bold">{targetedKws.length}</span>
                  </div>
                </div>
                <div className="rounded-xl border border-amber-200 overflow-hidden shadow-sm">
                  <table className="w-full text-left text-sm">
                    <TableHeader />
                    <tbody className="divide-y divide-amber-50">
                      {targetedKws.map(kw => <KwRow key={kw.id} kw={kw} />)}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {otherKws.length > 0 && (
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <div className="flex items-center gap-2 bg-slate-100 border border-slate-200 rounded-lg px-3 py-1.5">
                    <SafeIcon icon={FiBarChart2} className="text-slate-500 text-sm" />
                    <span className="text-sm font-semibold text-slate-600">Alte Cuvinte Cheie Analizate</span>
                    <span className="text-xs bg-slate-200 text-slate-600 px-1.5 py-0.5 rounded-full font-bold">{otherKws.length}</span>
                  </div>
                </div>
                <div className="rounded-xl border border-slate-200 overflow-hidden">
                  <table className="w-full text-left text-sm">
                    <TableHeader />
                    <tbody className="divide-y divide-slate-100">
                      {otherKws.map(kw => <KwRow key={kw.id} kw={kw} />)}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {allKws.length === 0 && (
              <div className="py-16 text-center text-slate-400">
                <SafeIcon icon={FiTarget} className="text-4xl mx-auto mb-3 text-slate-300" />
                <p className="font-medium">Niciun cuvânt cheie adăugat</p>
                <p className="text-sm mt-1">Adaugă primul keyword folosind formularul de mai sus</p>
              </div>
            )}
          </div>
        )}

        {/* ADVERTORIALS TAB */}
        {activeTab === 'advertorials' && (
          <div className="space-y-6">
            <form onSubmit={handleAddAdvertorial} className="grid grid-cols-1 md:grid-cols-4 gap-3 items-end">
              <div className="md:col-span-1">
                <label className="block text-xs font-medium text-slate-500 mb-1">Titlu *</label>
                <input name="title" placeholder="Titlu articol" required className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500 outline-none" />
              </div>
              <div className="md:col-span-1">
                <label className="block text-xs font-medium text-slate-500 mb-1">URL</label>
                <input name="url" placeholder="https://..." className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500 outline-none" />
              </div>
              <div>
                <label className="block text-xs font-medium text-slate-500 mb-1">Dată publicare</label>
                <input name="date" type="date" className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500 outline-none" />
              </div>
              <button type="submit" className="bg-teal-600 text-white px-4 py-2 rounded-lg flex items-center justify-center gap-2 hover:bg-teal-700 transition-colors text-sm font-medium">
                <SafeIcon icon={FiPlus} /> {t('addAdvertorial')}
              </button>
            </form>
            <div className="grid grid-cols-1 gap-3">
              {(website.advertorials || []).map(adv => (
                <div key={adv.id} className="p-4 border border-slate-200 rounded-xl flex justify-between items-center hover:border-teal-200 transition-colors group">
                  <div className="flex-1 min-w-0 mr-4">
                    <h4 className="font-semibold text-slate-800 group-hover:text-teal-700 transition-colors truncate">{adv.title}</h4>
                    {adv.url && <a href={adv.url} target="_blank" rel="noreferrer" className="text-sm text-indigo-500 hover:underline truncate block">{adv.url}</a>}
                  </div>
                  <div className="flex items-center gap-3 flex-shrink-0">
                    {adv.date ? (
                      <span className="flex items-center gap-1.5 text-[11px] uppercase tracking-wider font-bold text-slate-400 bg-slate-100 px-2.5 py-1 rounded-md">
                        <SafeIcon icon={FiCalendar} className="text-xs" /> {adv.date}
                      </span>
                    ) : <span className="text-[11px] text-slate-300 italic">fără dată</span>}
                    <button onClick={() => setEditingAdv(adv)} className="p-2 text-indigo-500 bg-indigo-50 rounded-lg hover:bg-indigo-100 transition-colors opacity-0 group-hover:opacity-100">
                      <SafeIcon icon={FiEdit2} className="text-sm" />
                    </button>
                    <button onClick={() => handleDeleteAdv(adv.id)} className="p-2 text-red-400 bg-red-50 rounded-lg hover:bg-red-100 transition-colors opacity-0 group-hover:opacity-100">
                      <SafeIcon icon={FiTrash2} className="text-sm" />
                    </button>
                  </div>
                </div>
              ))}
              {!(website.advertorials?.length) && <div className="p-12 text-center text-slate-400 italic">{t('noData')}</div>}
            </div>
          </div>
        )}

        {/* REPORTS TAB */}
        {activeTab === 'reports' && (
          <div className="space-y-8">
            {validKws.length === 0 ? (
              <div className="py-16 text-center text-slate-400 italic">
                <SafeIcon icon={FiBarChart2} className="text-4xl mx-auto mb-3 text-slate-300" />
                <p>Nu există date cu poziție și volum pentru a genera rapoarte.</p>
                <p className="text-sm mt-2">Apasă butonul <strong>Refresh</strong> la fiecare keyword pentru a prelua date reale din API.</p>
              </div>
            ) : (
              <div id="seo-report-container" ref={reportRef} className="space-y-8 bg-slate-50/50 p-6 md:p-8 rounded-2xl border border-slate-100">
                <div className="flex items-center justify-between pb-6 border-b border-slate-200">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-xl bg-white border border-slate-200 shadow-sm flex items-center justify-center overflow-hidden">
                      {faviconUrl && !faviconError ? <img src={faviconUrl} alt="" className="w-8 h-8 object-contain" onError={() => setFaviconError(true)} /> : <SafeIcon icon={FiGlobe} className="text-xl text-slate-400" />}
                    </div>
                    <div>
                      <h2 className="text-2xl font-bold text-slate-800 tracking-tight">{website.url}</h2>
                      <p className="text-slate-500 mt-0.5">{client.name} • Raport SEO generat {new Date().toLocaleDateString('ro-RO')}</p>
                    </div>
                  </div>
                  <div className="flex items-center justify-center bg-white rounded-xl px-5 py-3 shadow-sm border border-slate-100" style={{ width: '260px', height: '80px' }}>
                    <CompanyLogo />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                  <div className="bg-indigo-50 rounded-2xl p-6 border border-indigo-100 shadow-sm">
                    <p className="text-xs text-indigo-500 font-bold uppercase tracking-wider mb-2">Poziție Medie</p>
                    <p className="text-4xl font-black text-indigo-700">#{avgPosition}</p>
                    <p className="text-sm text-indigo-400 mt-2 font-medium">din {positions.length} keywords</p>
                  </div>
                  <div className="bg-emerald-50 rounded-2xl p-6 border border-emerald-100 shadow-sm">
                    <p className="text-xs text-emerald-600 font-bold uppercase tracking-wider mb-2">Top 10</p>
                    <p className="text-4xl font-black text-emerald-700">{top10Count}</p>
                    <p className="text-sm text-emerald-500 mt-2 font-medium">keywords în primele 10 rezultate</p>
                  </div>
                  <div className="bg-teal-50 rounded-2xl p-6 border border-teal-100 shadow-sm">
                    <p className="text-xs text-teal-600 font-bold uppercase tracking-wider mb-2">Volum Total</p>
                    <p className="text-4xl font-black text-teal-700">{totalVolume.toLocaleString()}</p>
                    <p className="text-sm text-teal-500 mt-2 font-medium">căutări/lună</p>
                  </div>
                </div>

                <div className="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
                  <table className="w-full text-sm">
                    <thead className="bg-slate-50 border-b border-slate-200">
                      <tr>
                        <th className="px-4 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">#</th>
                        <th className="px-4 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">Keyword</th>
                        <th className="px-4 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">Poziție</th>
                        <th className="px-4 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">Tendință</th>
                        <th className="px-4 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">Volum</th>
                        <th className="px-4 py-3 text-left text-xs font-bold text-slate-500 uppercase tracking-wider">Tip</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                      {sortedByPos.map((kw, i) => {
                        const trend = getTrend(kw);
                        const rc = getRankColor(Number(kw.position));
                        return (
                          <tr key={kw.id} className={`${kw.isTargeted ? 'bg-amber-50/50' : ''} hover:bg-slate-50 transition-colors`}>
                            <td className="px-4 py-3 text-slate-400 font-bold text-xs">{i + 1}</td>
                            <td className="px-4 py-3">
                              <div className="flex items-center gap-2 font-medium text-slate-800">
                                {kw.isTargeted && <SafeIcon icon={FiStar} className="text-amber-400 text-xs flex-shrink-0" />}
                                {kw.term}
                              </div>
                            </td>
                            <td className="px-4 py-3">
                              <span className={`inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-bold ${rc.light} ${rc.text}`}>
                                #{Number(kw.position)}
                              </span>
                            </td>
                            <td className="px-4 py-3">
                              {trend ? (
                                <span className={`inline-flex items-center gap-1 text-xs font-bold px-2 py-0.5 rounded-full border ${trend.color} ${trend.bg} ${trend.border}`}>
                                  <SafeIcon icon={trend.icon} className="text-xs" />
                                  {trend.type === 'up' ? `+${trend.diff}` : trend.type === 'down' ? `-${trend.diff}` : '='}
                                </span>
                              ) : <span className="text-xs text-slate-300 italic">Prima</span>}
                            </td>
                            <td className="px-4 py-3 text-slate-600 font-medium text-xs">
                              {kw.searchVolume !== '-' ? Number(kw.searchVolume).toLocaleString() : '-'}
                            </td>
                            <td className="px-4 py-3">
                              {kw.isTargeted
                                ? <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full font-bold border border-amber-200">Targetat</span>
                                : <span className="text-xs bg-slate-100 text-slate-500 px-2 py-0.5 rounded-full">Analizat</span>}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="pt-2">
                  <h3 className="text-lg font-bold text-slate-700 mb-4 flex items-center gap-2">
                    <SafeIcon icon={FiBarChart2} className="text-teal-500 text-xl" />
                    Volum de Căutări <span className="text-sm font-medium text-slate-400 ml-1">(căutări/lună)</span>
                  </h3>
                  <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6">
                    <ReactECharts option={volumeChartOptions} style={{ height: `${Math.max(250, validKws.length * 55)}px` }} />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default WebsiteDetail;